/**
 * 测速相关组件
 * */

//测速组件
Vue.component(
    'speedtest',
    resolve => require(["../../components/speed/Speedtest"], resolve)
);

//测速结束间距组件
Vue.component(
    'speedtest-finish',
    resolve => require(["../../components/SpeedtestFinish"], resolve)
);

//测速数据
Vue.component(
    'speedtest-data',
    resolve => require(["../../components/speedtestData"], resolve)
);

Vue.component(
    'canvas-chart',
    resolve => require(["../../components/CanvasChart"], resolve)
);


// 测速结果
Vue.component(
    "speed-result",
    resolve => require(["../../components/SpeedResult"], resolve)
);

// 测速详情
Vue.component(
    'speed-detail',
    resolve => require(["../../components/speedDetail/SpeedDetail"], resolve)
);

// // 测速详情适用场景
// Vue.component(
//     'speed-detail-classify',
//     require('../../components/speedDetail/SpeedDetailClassify')
// );

// 测速报告
Vue.component(
    'speed-report',
    resolve => require(["../../components/speedDetail/SpeedReport"], resolve)
);

// 网速知识
Vue.component(
    "bandwidth",
    resolve => require(["../../components/bandwidth/Index"], resolve)
)


// 宽带提速弹窗
Vue.component(
    'coupon-pop',
    require("../../components/homePage/couponPop/CouponPop")
)

// 附近网速-入口
Vue.component(
    'ad-neighbors',
    require("../../components/ads/AdNeighbors")
)
// 附近用户的测速报告(新-地图模式)
Vue.component(
    'neighbors',
    resolve => require(["../../components/history/Neighbors"], resolve)
)

// 附近网速顶部的广告位组件
Vue.component(
    'neighborsTopAds',
    resolve => require(["../../components/history/neighbors/NeighborsTopAds.vue"], resolve)
)

//测速分享组件
Vue.component(
    'share-result',
    resolve => require(["../../components/ShareResult"], resolve)
);



// WEBPACK FOOTER //
// ./resources/js/signCom/module/speedtest.js